export default __webpack_public_path__ + "static/media/Rizing.02d500e5.png";